import { createContext, useState, useContext } from "react";
import UnitContext from "./unit-context";

const ParseContext = createContext({
  parseAmount: (line) => {},
  parseUnit: (line) => {}
});

export function ParseContextProvider(props) {
  const unitContext = useContext(UnitContext)

  function regexParser(line, regex, removeFromStart = true) {
    line = line.trimStart();
    var result = line.match(regex);
    if (result != null) {
      var returnLine = "";

      if (removeFromStart) {
        returnLine = line.substring(result[0].length);
      } else {
        returnLine = line.substring(0, line.length - result[0].length)
      }
      return {
        result: result[0] ?? null,
        line: returnLine,
      };
    } else {
      return null;
    }
  }

  function fractionToDecimal(amount) {
    const regexIntEndOfString = /[0-9]+$/g;
    const regexFowardSlashEndOfString = /[/]$/;

    function parse(regex) {
      const result = regexParser(amount, regex, false)
      if (result != null) {
        amount = result.line;
        return result.result;
      } else {return null; }
      
    }

    const numberAfterSlash = parse(regexIntEndOfString)

    parse(regexFowardSlashEndOfString)

    const numberBeforeSlash  = parse(regexIntEndOfString)

    if (amount.length == 0) {
      return parseFloat(numberBeforeSlash / numberAfterSlash);
    } else {
      return parseFloat(amount) + parseFloat(numberBeforeSlash / numberAfterSlash);
    }
        
  }

  function parseAmount(line) {
    const regexInt = /^[0-9]+/;
    const regexDecamal = /^[.]/g;
    const regexWhiteSpace = /^\s/g;
    const regexFowardSlash = /^[/]/;
    var amount = null;
    var amountContainsFraction = false;

    function parse(regex, whiteSpace = "", removeWhiteSpace = true) {
      var results = regexParser(line, regex);
      if (results != null) {
        if (amount == null) {
          amount = whiteSpace + results.result;
        } else {
          amount += whiteSpace + results.result;
        }
        if (removeWhiteSpace) {
          line = results.line.trimStart();
        } else {
          line = results.line;
        }
      }
    }

    parse(regexInt, "", false);

    if (line.match(regexWhiteSpace)) {
      parse(regexInt, " ");
    }
    
    amountContainsFraction = line.match(regexFowardSlash) != null;
    
    parse(regexFowardSlash);
    parse(regexInt);

    parse(regexDecamal);
    parse(regexInt);


    if (amountContainsFraction) {
      amount = fractionToDecimal(amount)
    }

    if (amount != null) {
      return {
        amount: amount,

        line: line.trimStart(),
      };
    } else {
      return null;
    }
  }

  function parseUnit(line) {
    const unitRegex = RegExp(
      "(\\b)(" +
        Object.values(unitContext.units).flat().join("|") +
        ")(\\b)|^[×]",
      "gi"
    );

    const parsed = regexParser(line, unitRegex);
    var unit = null;
    if (parsed) {
      line = parsed.line;
      unit = parsed.result;
    } else {
      unit = "x";
    }

    return {
      unit: unitContext.updateUint(unit),
      line: line.trimStart(),
    };
  }

  const context = {
    parseAmount: parseAmount,
    parseUnit: parseUnit,
  };

  return(
    <ParseContext.Provider value={context}>
      {props.children}
    </ParseContext.Provider>
  );
}

export default ParseContext;